import {ValueObject} from '@s-ui/domain'

import {FilterStringSearchValueObject} from './FilterStringSearchValueObject.js'

export class FilterCitySearchValueObject extends ValueObject {
  #city

  constructor({city}) {
    super()
    this.#city = city
  }

  static create({city}) {
    return new FilterCitySearchValueObject({city: FilterStringSearchValueObject.create(city)})
  }

  static createWithDefaultValue({config, city}) {
    const {DEFAULT_CITY_SEARCH} = config.get('searchFilters')

    return new FilterCitySearchValueObject({
      city: FilterStringSearchValueObject.create({string: city ?? DEFAULT_CITY_SEARCH})
    })
  }

  get isEmpty() {
    return this.#city.isEmpty
  }

  get value() {
    return this.#city.value
  }

  toJSON() {
    return {
      city: this.#city.toJSON()
    }
  }
}
